'use strict';

var _ = require('lodash'),
    productTile = require('_core_ext/product-tile'),
    progress = require('_core_ext/progress'),
    addToCart = require('_core_ext/pages/product/addToCart'),
    util = require('_core_ext/util'),
    refinements = require('_core_ext/pages/search/refinements'),
    JSConstants = require('_core_ext/pages/search/constants'),
    layout = require('_core_ext/layout'),
    cssConstants = require('_core_ext/cssconstants'),
    sessionStorage = require('_core_ext/storage');

var $cache = {},
    searchActive = false,
    viewSession = 'searchResultViewCss';

function initializeCache() {
    $cache.body = $(JSConstants.CLASS_BODY);
}

function setViewToSession(viewCss) {
    sessionStorage.setItem(viewSession, viewCss);
}

function getViewClassFromSession() {
    var viewModeClass = sessionStorage.getItem(viewSession);

    if (viewModeClass !== null) {
        return viewModeClass;
    }

    viewModeClass = cssConstants.TILE_GRID;
    setViewToSession(viewModeClass);
    return viewModeClass;
}

function setToggle(view) {
    $(JSConstants.CLASS_TOGGLE_GRID + '[data-option=' + view + ']').addClass('active').siblings().removeClass('active');
}

function showFullDescription(isFull) {
    var $desc = $(JSConstants.CLASS_SEARCH_FULLDESC),
        $readmore = $(JSConstants.CLASS_SEARCH_READMORE);
    if ($desc.length < 1 || !$desc.text()) {
        return;
    }

    var dataAttr = 'full',
        currentText = $desc.text(),
        strLength = layout.isMobile() ? 100 : 400;

    if (isFull) {
        var full = $desc.data(dataAttr);

        $desc.removeData(dataAttr);
        $desc.text(full);
        $readmore.addClass(cssConstants.HIDDEN);
    } else {
        $desc.data(dataAttr, currentText);
        var short = util.getTrimString(currentText, strLength, ' ...');
        $desc.text(short);

        if (short < currentText) {
            $readmore.removeClass(cssConstants.HIDDEN);
        }
    }
}

function initializeSearchView() {
    if (!$(JSConstants.CLASS_TILE_CONTAINER).length) {
        return;
    }

    var currentView = getViewClassFromSession();

    if (currentView !== null) {
        $(JSConstants.CLASS_TILE_CONTAINER).addClass(currentView);
        setToggle(currentView);
    }

    showFullDescription(false);
}

function gridViewToggle() {
    var $this = $(this),
        newViewClass = $this.data('option') === 'tile-wide' ? cssConstants.TILE_WIDE : cssConstants.TILE_GRID,
        currentView = getViewClassFromSession();

    if (currentView === newViewClass) {
        return;
    }

    $(JSConstants.CLASS_TILE_CONTAINER)
        .removeClass(currentView)
        .addClass(newViewClass);

    setViewToSession(newViewClass);
    setToggle(newViewClass);
}

function infiniteScroll() {
    // getting the hidden div, which is the placeholder for the next page
    var dataUrl = 'data-grid-url',
        dataLoading = 'data-loading-state',
        $plpLoader = $(JSConstants.CLASS_PLP_LOADER),
        $loadMore = $(JSConstants.CLASS_SEARCH_LOADMORE),
        $loadPlaceHold = $(JSConstants.CLASS_SCROLL_PLACEHOLDER + '[' + dataLoading + '="unloaded"]'),
        gridUrl = '';

        if ($loadPlaceHold && $loadPlaceHold.length === 1) {
        gridUrl = $loadPlaceHold.attr(dataUrl);
    }

    if (gridUrl) {
        $loadPlaceHold.addClass(cssConstants.LOADING).attr(dataLoading, 'loading');
        $loadMore.addClass(cssConstants.LOADING).prop('disabled', true);
        $plpLoader.addClass(cssConstants.LOADING);

        // named wrapper function, which can either be called, if cache is hit, or ajax repsonse is received
        var fillEndlessScrollChunk = function (html) {
            $loadPlaceHold.removeClass(cssConstants.LOADING).attr(dataLoading, 'loaded');
            $(JSConstants.CLASS_PRODUCT_GRID).append(html);
            var hasUnloaded = $(JSConstants.CLASS_SCROLL_PLACEHOLDER + '[' + dataLoading + '="unloaded"]').length > 0;
            $plpLoader.removeClass(cssConstants.LOADING);

            if (!hasUnloaded) {
                $loadMore.hide();
            } else {
                $loadMore.removeClass(cssConstants.LOADING).prop('disabled', false);
            }
        };

        $.ajax({
            type: 'GET',
            dataType: 'html',
            url: gridUrl,
            success: function (response) {
                // put response into cache
                try {
                    sessionStorage['scroll-cache_' + gridUrl] = response;
                } catch (e) {
                    console.warn(e.message);
                }

                // update UI
                fillEndlessScrollChunk(response);
                productTile.init({
                    initQuickView : false
                });
                $(document).trigger('products.loaded');
                if (SitePreferences.MONETATE_ENABLED) {
                    window.initMonetateTracking();
                }
            }
        });
    }
}

/**
 * @private
 * @function
 * @description replaces breadcrumbs, lefthand nav and product listing with ajax and puts a loading indicator over the product listing
 */
function updateProductListing(url, isScroll, isPopstateUpdated = false) {
    if (!searchActive && (!url || (!isPopstateUpdated && url === window.location.href))) {
        return;
    }
    searchActive = true;
    progress.show($(JSConstants.CLASS_TILE_CONTAINER));
    var ajaxUrl = util.appendParamToURL(url, 'format', 'ajax');

    $(JSConstants.CLASS_MAIN).load(ajaxUrl, function () {
        productTile.init({
            initQuickView : false
        });

        var $desktop = $(JSConstants.CLASS_MAIN);
        var $dialog = $(JSConstants.CLASS_REFINEMENT_DIALOG);
        var $updatedRefinements = $desktop.find(JSConstants.CLASS_SORT_REFINEMENT_WRAPPER);

        if (layout.isMobile() && $dialog.length && $updatedRefinements.length) {
            var updatedRefinementsMarkup = $updatedRefinements.html();

            $dialog.find(JSConstants.CLASS_SORT_REFINEMENT_WRAPPER).html(updatedRefinementsMarkup);
            $dialog.find('.noUi-base').remove();

            refinements.initUiSlider($dialog);
            refinements.checkSelectedRefinements();
            refinements.initDialogState();

        } else if ($desktop.length) {
            refinements.initUiSlider($desktop);
        }

        progress.hide();
        history.pushState(null, '', url);

        refinements.initRefirementBlock();
        $(document).trigger('products.loaded');

        if (isScroll) {
            util.scrollBrowserTo($(JSConstants.CLASS_MAIN));
        }

        $(JSConstants.CLASS_SEARCH_BREADCRUMBS).slice(1).remove();
        initializeSearchView();
        searchActive = false;
        if (SitePreferences.MONETATE_ENABLED) {
            window.initMonetateTracking();
        }
    });
}

/**
 * @private
 * @function
 * @description Initializes events for the following elements:<br/>
 * <p>refinement blocks</p>
 * <p>updating grid: refinements, pagination, breadcrumb</p>
 * <p>item click</p>
 * <p>sorting changes</p>
 */
function initializeEvents() {
    var $main = $(JSConstants.CLASS_MAIN),
        $searchContainer = $(JSConstants.CLASS_NO_SEARCH_CONTAINER),
        $searchForm = $searchContainer.find(JSConstants.CLASS_NO_SEARCH_FORM),
        $searchField = $searchForm.find('input[name="q"]');

    window.addEventListener("popstate", function () {
        updateProductListing(window.location.href, true, true);
    });


    $main.on('click', JSConstants.CLASS_PAGINATION_CONTAINER + ' a', function (e) {
        var $this = $(this);
        if ($this.parents(JSConstants.CLASS_CATEGORY_REFINEMENT).length > 0 || $this.parents(JSConstants.CLASS_FOLDER_REFINEMENT).length > 0 || $this.parent().hasClass('unselectable')) {
            return;
        }
        e.preventDefault();
        updateProductListing(this.href, true);
    });

    // handle events for updating grid
    $main.on('search.update', function (e, data) {
        updateProductListing(data.targetURL);
    });

    if (SitePreferences.LISTING_INFINITE_SCROLL && pageContext.ns !== 'blog') {
        $main.on('click', JSConstants.CLASS_SEARCH_LOADMORE, function(e) {
            e.preventDefault();
            infiniteScroll();
        });

        $(window).on('scroll', _.debounce(function() {
            var y = $(window).scrollTop(), loadY,
                $loadMore = $(JSConstants.CLASS_SEARCH_LOADMORE);

            if ($loadMore && $loadMore.length) {
                loadY = $loadMore.offset().top - 100;
            }

            if (loadY && y > loadY) {
                infiniteScroll();
            }
        }, 250));
    }

    // handle events item click. append params.
    $main.on('click', '.js-tile a:not("#quickviewbutton")', function () {
        var a = $(this);
        // get current page refinement values
        var wl = window.location;

        var qsParams = (wl.search.length > 1) ? util.getQueryStringParams(wl.search.substr(1)) : {};
        var hashParams = (wl.hash.length > 1) ? util.getQueryStringParams(wl.hash.substr(1)) : {};

        // merge hash params with querystring params
        var params = $.extend(hashParams, qsParams);
        if (!params.start) {
            params.start = 0;
        }
        // get the index of the selected item and save as start parameter
        var tile = a.closest('.js-tile');
        var idx = tile.data('idx') ? + tile.data('idx') : 0;

        // convert params.start to integer and add index
        params.start = (+params.start) + (idx + 1);
        // set the hash and allow normal action to continue
        a[0].hash = $.param(params);
    });

    // handle sorting change
    $main.on('change', '.sort-by select', function (e) {
        e.preventDefault();
        updateProductListing($(this).find('option:selected').val());
    })

    .on('change', JSConstants.CLASS_ITEMS_PER_PAGE, function () {
        var refineUrl = $(this).find('option:selected').val();
        if (refineUrl === 'INFINITE_SCROLL') {
            $('html').addClass('infinite-scroll').removeClass('disable-infinite-scroll');
        } else {
            $('html').addClass('disable-infinite-scroll').removeClass('infinite-scroll');
            updateProductListing(refineUrl);
        }
    })

    .on('click', JSConstants.CLASS_TOGGLE_GRID, gridViewToggle)
    .on('click', JSConstants.CLASS_SEARCH_READMORE, function(e) {
        e.preventDefault();
        showFullDescription(true);
    })

    .on('click', JSConstants.CLASS_SEARCH_BACK, function(e) {
        e.preventDefault();
        history.back();
    });

    // do not submit form if search box is empty
    $searchForm.on('submit', function (event) {
        var searchFieldValue = $searchField.val(),
            searchFieldFilled = searchFieldValue && searchFieldValue.length && searchFieldValue !== $searchField.attr('placeholder');

        if (!searchFieldFilled) {
            event.preventDefault();
        }
    });

}

function initializeSEOText() {
    var seo_text = $(JSConstants.CLASS_SEARCH_SEO_TEXT);
    var button = $(JSConstants.CLASS_SEARCH_READMORE);

    if (seo_text.length === 0) {
        return;
    }

    var originalHeight = seo_text.outerHeight();

    seo_text.addClass('expanded');
    var fullHeight = seo_text.outerHeight();
    seo_text.removeClass('expanded');

    if (fullHeight > originalHeight) {
        button.removeClass('hidden');
    }

    button.on('click', function () {
        seo_text.toggleClass('expanded');

        if (seo_text.hasClass('expanded')) {
            button.text(button.data('readless'));
        } else {
            button.text(button.data('readmore'));
        }
    });
}

var search = {
    init: function() {
        productTile.init({
            initQuickView : false
        });
        initializeCache();
        initializeSearchView();
        initializeEvents();
        initializeSEOText();
        addToCart();
    }
};

module.exports = search;
